import type { Quote } from '@talos/kyoko';
import type { MenuItemDef } from 'ag-grid-community';
import { compact } from 'lodash-es';
import { useCallback, type ReactNode } from 'react';
import { useForceCancelCareOrderChildMenuItem } from '../../CareOrders/MenuItems/useForceCancelCareOrderChildMenuItem';
import { useShowRFQMenuItem } from './useShowRFQMenuItem';
import { useShowTakerQuoteBreakdownMenuItem } from './useShowTakerQuoteBreakdownMenuItem';

/**
 * Shared quote context-menu actions used by Quotes blotters and Care Order quote rows.
 * Keeps action order and dialog ownership aligned across call sites.
 */
export function useQuoteContextMenuActions(): {
  getQuoteActionMenuItems: (quote: Quote) => Array<MenuItemDef>;
  dialog: ReactNode;
} {
  const { getForceCancelCareOrderChildQuoteItem, dialog } = useForceCancelCareOrderChildMenuItem();
  const getShowRFQMenuItem = useShowRFQMenuItem();
  const getShowTakerQuoteBreakdownMenuItem = useShowTakerQuoteBreakdownMenuItem();

  const getQuoteActionMenuItems = useCallback(
    (quote: Quote) =>
      compact([
        getShowRFQMenuItem(quote),
        getShowTakerQuoteBreakdownMenuItem(quote),
        getForceCancelCareOrderChildQuoteItem(quote),
      ]),
    [getForceCancelCareOrderChildQuoteItem, getShowRFQMenuItem, getShowTakerQuoteBreakdownMenuItem]
  );

  return {
    getQuoteActionMenuItems,
    dialog,
  };
}
